import React, { useEffect, useState } from 'react';
import {
  Grid, LinearProgress, FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
} from '@material-ui/core';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import i18n from '@i18n';
import { useRoles, useAnalisisRoles } from '@hooks';
import {
  Alert, Autocomplete, ButtonAdorned, Subtitle,
} from '@components/atoms';

const EditAnalisis = () => {
  const { pages: { employees: { presupuestos: { edit: texts } } } } = i18n;
  const history = useHistory();
  const {
    getRoles, rolesError, isRolesLoading,
  } = useRoles();
  const {
    getAnalisisRol, analisisRolesError, editAnalisisRol, createAnalisisRol, isAnalisisRolesLoading,
  } = useAnalisisRoles();
  const [rol, setRol] = useState('');
  const [roles, setRoles] = useState({
    id: '',
    rol_id: '',
    name: '',
  });
  const [steps, setSteps] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const form = useFormik({
    initialValues: {
      id: '',
      steps,
    },
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: async () => {
      if (rol.id) {
        const updated = await editAnalisisRol({ ...rol, steps });
        if (updated) {
          enqueueSnackbar(texts.success, { variant: 'success' });
          history.push('/e/roles');
        }
      } else {
        const created = await createAnalisisRol({ rol_id: rol.rol_id, steps });
        if (created) {
          enqueueSnackbar(texts.success, { variant: 'success' });
          history.push('/e/roles');
        }
      }
    },
  });

  useEffect(async () => {
    const serviceRoles = await getRoles();
    // const currentState = true;
    setRoles(serviceRoles);
  }, []);

  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const onChangeRol = async (_, value) => {
    if (!value) return;
    const response = await getAnalisisRol(value.id);
    setRol({ ...rol, rol_id: value.id });
    // biome-ignore lint/complexity/useOptionalChain: <ebiome>
    if (response && response.steps && Array.isArray(response.steps)) {
      setRol({ id: response.id, rol_id: response.rol_id });
      setSteps(response.steps);
    } else {
      setRol({ id: undefined, rol_id: value.id });
      setSteps([
        { id: 'ingreso', enabled: false },
        { id: 'asignacion', enabled: false },
        { id: 'ejecucion', enabled: false },
        { id: 'revision', enabled: false },
        { id: 'redaccion', enabled: false },
      ]);
    }
  };

  const handleCheckboxChange = (event) => {
    const id = event.target.name;
    setSteps((prev) => prev.map((etapa) => (etapa.id === id
      ? { ...etapa, enabled: !etapa.enabled }
      : etapa)));
  };

  return (
    <>
      {rolesError && <Alert>{rolesError.message}</Alert>}
      {analisisRolesError && <Alert>{analisisRolesError.message}</Alert>}
      { (isRolesLoading) ? <LinearProgress /> : (
        <>
          <Grid container spacing={2}>
            {texts.subtitleData && (
            <Grid item xs={12} align="left">
              <Subtitle>Asignación de roles a flujo de analisis</Subtitle>
            </Grid>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} style={{ paddingTop: 15 }}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                label="Rol"
                onChange={onChangeRol}
                error={form.touched.roles && Boolean(form.errors.roles)}
                disabled={isRolesLoading}
                helperText={(roles.length === 0 && !isRolesLoading && texts.noContacts)}
                items={roles}
              />
            </FormControl>
          </Grid>
          {(isAnalisisRolesLoading) ? <LinearProgress style={{ marginTop: 10, marginBottom: 10 }} /> : (
            <Grid container spacing={2} style={{ paddingTop: 15 }}>
              {steps.map((step) => (
                <Grid key={step.id} item xs={12}>
                  <FormControl style={{ flexDirection: 'row' }}>
                    <FormLabel style={{ alignSelf: 'center', minWidth: 120 }}>{capitalizeFirstLetter(step.id)}</FormLabel>
                    <FormControlLabel
                      control={<Checkbox name={step.id} checked={step.enabled} onChange={handleCheckboxChange} />}
                    />
                  </FormControl>
                </Grid>
              ))}
            </Grid>
          )}
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <ButtonAdorned color="default" onClick={() => history.push('/e/roles')}>
                {texts.list}
              </ButtonAdorned>
            </Grid>
            <Grid item>
              <form onSubmit={form.handleSubmit}>
                <ButtonAdorned disabled={isAnalisisRolesLoading || isRolesLoading || !rol} type="submit">
                  {texts.save}
                </ButtonAdorned>
              </form>
            </Grid>
          </Grid>

        </>
      )}
    </>
  );
};

export default EditAnalisis;
